export const categories = [
  { text: 'Kitchens', value: 'kitchens' },
  { text: 'Dining Rooms', value: 'dining-rooms' },
  { text: 'Living Rooms', value: 'living-rooms' },
  { text: 'Exteriors', value: 'exteriors' },
  { text: 'Bedrooms', value: 'bedrooms' },
  { text: 'Bathrooms', value: 'bathrooms' },
  { text: '3D Tours', value: '3d-tours' },
];
